<!--
 * @LastEditors: wuyanfeiying
 * @desc: 最近记录的 图（echarts)
 * @场景: 重构因子-点击左下角-计算完成-出来 | 点击 检测按钮
-->
<template>
  <div style="text-align: left;">
    <div :id="this.id" :style="{height: '400px', width: '100%'}"></div>
    <div style="float: right;">
      <el-button v-if="this.serieData.length > 0 && this.allNameList.length === 3 && this.scatterTwo" class="revert" style="padding: 3px;" size="mini" @click="handleClick()">三维</el-button>
      <el-button v-else-if="this.serieData.length > 0 && this.allNameList.length === 3 && !this.scatterTwo" class="revert" style="padding: 3px;" size="mini" @click="handleClick()">二维</el-button>
    </div>
    <div v-if="this.auto_scatter_plot && this.serieData.length > 0" style="margin-top: 20px;">
      <reconstrucScatter
        v-if="(this.allNameList.length === 3 && this.scatterTwo) || this.allNameList.length === 2"
        :id="'dialogScatter'"
        :serieName="this.serieName"
        :serieData="this.serieData"
        :serie3Data="this.serie3Data">
      </reconstrucScatter>
      <scatter3D
        v-else-if="this.allNameList.length === 3 && !this.scatterTwo"
        :id="'dialogScatter3D'"
        :serieName="this.serieName"
        :serieData="this.serieData">
      </scatter3D>
    </div>
  </div>
</template>
<script>
import { getRequest } from '@/api/dailyBackTest.js'
import { updateOptionSeries, updateOptionLegend, removeOptionSeries, removeOptionLegend } from '@/api/updateGraphOption.js'
import reconstrucScatter from '@/components/dailyBack/reconstrucScatter'
import scatter3D from '@/components/dailyBack/scatter3D'
export default {
  components: {
    reconstrucScatter,
    scatter3D
  },
  props: ['detailData', 'id', 'addTemporary', 'lineDetection', 'delectedTemporary', 'yAxisData', 'auto_scatter_plot', 'hide_zero', 'hide_nan', 'axisVisited', 'activeName'],
  data () {
    return {
      myChart: null,
      option: {},
      theLabel: [],
      theData: [],
      theLabels: [],
      theDatas: [],
      oldTimes: [],
      allList: [],
      markAreaData: [],
      markLineData: [],
      markPointData: [],
      allNameList: [],
      addTable: {},
      serieData: [],
      serie3Data: [],
      serieName: [],
      scatterTwo: false,
      timer: '',
      maxNum: '',
      minNum: ''
    }
  },
  mounted () {
    var _this = this
    window.tableClick = function (data) {
      _this.$emit('drawDate', data)
    }
    let scatterEdition = localStorage.getItem('scatterTwo')
    if (scatterEdition === 'true') {
      this.scatterTwo = true
    } else {
      this.scatterTwo = false
    }
    this.clearData()
  },
  methods: {
    handleClick () {
      this.scatterTwo = !this.scatterTwo
      localStorage.setItem('scatterTwo', this.scatterTwo)
    },
    drawLine () {
      // 基于准备好的dom，初始化echarts实例
      if (this.myChart === null) {
        this.myChart = this.$echarts.init(document.getElementById(this.id))
      }
      // 绘制图表
      this.option = {
        tooltip: {
          trigger: 'axis',
          triggerOn: 'click',
          confine: true,
          enterable: true,
          formatter: (param) => {
            let data = param[0]
            let text = '<span style="user-select: text;">' + data.name + '</span><br/>'
            for (let i = 0; i < param.length; i++) {
              let value = param[i].value
              if (value === null && value === undefined) {
                value = '-'
              }
              text = text + '<span style="display:inline-block;margin-right:5px;border-radius:50%;width:10px;height:10px;left:5px;background-color:' + param[i].color + '"></span><span style="user-select: text;">' + param[i].seriesName + '：' + value + '</span><br/>'
            }
            return text + '<button style="line-height: 24px; background: #fff; color: #444;" onclick="tableClick(\'' + data.name + '\')">详情</button>'
          },
          extraCssText: 'max-width: 450px; white-space: normal; word-break: break-all;'
        },
        toolbox: {
          feature: {
            saveAsImage: {
              show: true,
              type: 'png',
              name: '重构曲线'
            }
          },
          top: -5,
          show: true
        },
        legend: {
          show: true,
          data: [this.lineDetection],
          selected: {
            [this.lineDetection]: true
          },
          type: 'scroll',
          width: '90%',
          backgroundColor: 'transparent',
          // itemWidth: 40,
          // right: '30px',
          formatter: (name) => {
            const seriesitem = this.option.series.find(v => v.name === name)
            if (seriesitem && seriesitem.yAxisIndex != null) {
              return this.formatLegend(name, seriesitem.yAxisIndex)
            }
            if (this.option.legend.data.length > 1) {
              return name + '(左)'
            }
            return name
          }
        },
        grid: {
          show: true,
          z: 0,
          top: 70,
          right: 80
        },
        xAxis: {
          type: 'category',
          data: this.theLabels,
          // 网格样式
          splitLine: {
            show: true
          },
          boundaryGap: false
        },
        yAxis: [{
          boundaryGap: ['0%', '10%'],
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          min: 'dataMin',
          max: 'dataMax'
        },
        {
          boundaryGap: ['0%', '10%'],
          type: 'value',
          axisLabel: {
            formatter: '{value}'
          },
          min: 'dataMin',
          max: 'dataMax'
        }],
        color: ['#c64743', '#5470c6', '#3ba272', '#fac858', '#ee6666', '#91cc75', '#73c0de', '#fc8452', '#9a60b4', '#ea7ccc'],
        series: [{
          name: this.lineDetection,
          data: this.theDatas,
          type: 'line',
          // symbolSize: 10,
          connectNulls: true,
          lineStyle: {
            width: 2 // 设置线条粗细
          },
          markArea: {
            data: [],
            itemStyle: {
              opacity: 0.5
            }
          },
          markLine: {
            data: [],
            symbol: ['none', 'none'], // ['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
            label: {
              color: '#FFF',
              position: 'end' // 将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
            },
            silent: true, // 鼠标悬停事件 true没有，false有
            lineStyle: { // 警戒线的样式 ，虚实 颜色
              opacity: 0.7,
              type: 'solid', // 样式  ‘solid’和'dotted'
              width: 2 // 宽度
            }
          },
          markPoint: {
            itemStyle: {
              opacity: 0
            },
            data: []
          }
        }],
        dataZoom: [
          {
            type: 'inside',
            startValue: this.theLabels[0],
            endValue: this.theLabels[this.theLabels.length - 1]
          },
          {
            show: true,
            type: 'slider',
            fillerColor: 'rgba(167, 183, 204, 0.4)',
            // handleStyle: {
            //   color: '#a7b7cc',
            //   borderColor: '#000'
            // },
            top: '90%'
          }
        ]
      }
      var _this = this
      this.myChart.setOption(this.option)
      // console.log(this.detailData.data_info)
      if (this.detailData.data_info && this.detailData.data_info.date_desc) {
        var width = this.myChart.getWidth()
        var n = width / 140
        var t = this.detailData.data_info.date_desc.length
        this.updataMarkPoint(n, t, 0, this.theLabels.length)
      }
      // console.log('dataZoom')
      window.addEventListener('resize', function () {
        _this.myChart.resize()
        if (_this.myChart) {
          _this.myChart.resize()
        }
      })
      this.myChart.on('dataZoom', function (params) {
        if (_this.detailData.data_info) {
          let startValue = _this.myChart.getModel().option.dataZoom[0].startValue
          let endValue = _this.myChart.getModel().option.dataZoom[0].endValue
          _this.updataMarkPoint(n, t, startValue, endValue)
        }
      })
    },

    // 获取Echart option
    getEchartOption () {
      return this.myChart ? this.myChart.getOption() : null
    },
    updataMarkPoint (n, t, startValue, endValue) { // 是否显示markPoint
      let x = (endValue - startValue) / this.theLabels.length
      this.option['dataZoom'][0].startValue = startValue
      this.option['dataZoom'][0].endValue = endValue
      if (x < (n / t) && this.option['series'][0]['markPoint'].itemStyle.opacity === 0) {
        this.option['series'][0]['markPoint'].itemStyle.opacity = 1
        this.myChart.setOption(this.option)
      } else if (x > (n / t) && this.option['series'][0]['markPoint'].itemStyle.opacity === 1) {
        this.option['series'][0]['markPoint'].itemStyle.opacity = 0
        this.myChart.setOption(this.option)
      }
    },
    clearData () {
      Object.assign(this.$data, this.$options.data.call(this))
      this.myChart = this.$echarts.init(document.getElementById(this.id))
      this.myChart.clear()
    },
    unique (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr) && res.set(arr, 1))
    },
    uniqueId (arr) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr.id) && res.set(arr.id, 1))
    },
    scatterChart () {
      this.serieData = []
      this.serie3Data = []
      this.serieName = []
      if (this.allNameList.length === 2 || this.allNameList.length === 3) {
        this.serie3Data[0] = []
        this.serie3Data[1] = []
        for (let j = 0; j < this.allNameList.length; j++) {
          let boolName = this.allNameList[j].name
          if (boolName.length > 20) {
            boolName = boolName.replace(/(.{20})/g, '$1\n')
          }
          if (boolName === this.lineDetection) {
            this.serieName.push(this.lineDetection)
          } else {
            this.serieName.push(boolName)
          }
        }
        for (let i = 0; i < this.oldTimes.length; i++) {
          let item = []
          let flag = false
          for (let z = 0; z < this.allNameList.length; z++) {
            let boolName = this.allNameList[z].name
            let data = this.allList[boolName].updataData[i]
            if (!data && data !== 0) {
              flag = true
            } else {
              item.push(data)
            }
          }
          if (flag === false) {
            if (this.allNameList.length === 3) {
              let x = this.allNameList[0].name
              let y1 = this.allNameList[1].name
              let y2 = this.allNameList[2].name
              this.serie3Data[0].push([this.allList[x].updataData[i], this.allList[y1].updataData[i]])
              this.serie3Data[1].push([this.allList[x].updataData[i], this.allList[y2].updataData[i]])
            }
            this.serieData.push(item)
          }
        }
      }
    },
    getNewLabels (addlabels) { // 合并x轴
      var addTimes = addlabels
      for (let i = 0; i < addlabels.length; i++) {
        if (typeof addlabels[i] !== 'string') {
          addlabels[i] = JSON.stringify(addlabels[i])
        }
      }
      var newTimes = this.oldTimes.concat(addTimes)
      newTimes = this.unique(newTimes).sort()
      this.theLabels = newTimes
      this.option['xAxis'].data = this.theLabels
      return newTimes
    },
    getNaNData (newTimes) { // 获取与新x轴长度相同的全为空值的数组
      var nanData = []
      for (let i = 0; i < newTimes.length; i++) {
        nanData.push(NaN)
      }
      return nanData
    },
    updataOneLine (newData, newTimes) { // 变更当前曲线内容
      this.markAreaData = []
      this.markLineData = []
      if (this.detailData.is_bool === true && this.detailData.dimension !== 'two') {
        let item = this.getmarkArea(newData, newTimes)
        this.markAreaData = item.markAreaData
        this.markLineData = item.markLineData
      }
      this.theDatas = newData
      this.option['series'][0]['markArea'].data = []
      this.option['series'][0]['markLine'].data = []
      if (this.markAreaData.length > 0) {
        this.option['series'][0]['markArea'].data = this.markAreaData
      }
      if (this.markLineData.length > 0) {
        this.option['series'][0]['markLine'].data = this.markLineData
      }
      if (this.markLineData.length < 1 && this.markAreaData.length < 1) {
        this.option['series'][0].data = this.theDatas
      } else {
        this.option['series'][0].type = 'bar'
        this.option['series'][0].data = [0]
      }
      if (this.markPointData.length > 0) {
        this.option['series'][0]['markPoint'].data = this.markPointData
      }
      this.myChart.setOption(this.option)
    },
    updataLine (addlabels) { // 合并x轴及旧数据曲线
      // 合并x轴
      var newTimes = this.getNewLabels(addlabels)
      // 处理旧y轴数据曲线，将没有对应日期的value赋一个空值
      var nanData = this.getNaNData(newTimes)
      // y轴预准备处理
      if (this.oldTimes.length !== newTimes.length) { // 如果x轴发生变化
        var newData = []
        for (let z = 0; z < this.allNameList.length; z++) {
          newData = JSON.parse(JSON.stringify(nanData))
          let boolName = this.allNameList[z].name
          for (let j = 0; j < this.oldTimes.length; j++) {
            let index = newTimes.indexOf(this.oldTimes[j]) // 新x轴包含旧x轴数据
            if (index > -1) {
              newData[index] = this.allList[boolName].updataData[j]
            }
          }
          this.allList[boolName].updataData = newData // 原y轴备份
          if (this.allNameList[z].isBool === false && boolName !== this.lineDetection) { // 非当前检测数据，非0/1数据
            var querys = boolName
            var contents = {
              name: querys,
              data: newData,
              type: 'line',
              connectNulls: true,
              lineStyle: {
                width: 2 // 设置线条粗细
              }
            }
            if (this.allNameList[z].yAxisIndex === true) { // 是否右轴
              contents.yAxisIndex = 1
            } else {
              contents.yAxisIndex = 0
            }
            removeOptionSeries(this.option, querys)
            updateOptionSeries(this.option, querys, contents)
            this.myChart.setOption(this.option) // 原对比数据变更处理
          } else if (boolName === this.lineDetection) {
            this.updataOneLine(newData, newTimes)
          } else if (this.allNameList[z].isBool === true) {
            let item = this.getmarkArea(newData, newTimes)
            var markAreaData = item.markAreaData
            var markLineData = item.markLineData
            var query = boolName
            var content = {
              name: query,
              data: [0],
              type: 'bar',
              connectNulls: false,
              lineStyle: {
                width: 2 // 设置线条粗细
              },
              markArea: {
                data: markAreaData,
                itemStyle: {
                  opacity: 0.5
                }
              },
              markLine: {
                data: markLineData,
                symbol: ['none', 'none'], // ['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
                label: {
                  color: '#FFF',
                  position: 'end' // 将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
                },
                silent: true, // 鼠标悬停事件 true没有，false有
                lineStyle: { // 警戒线的样式 ，虚实 颜色
                  opacity: 0.7,
                  type: 'solid', // 样式  ‘solid’和'dotted'
                  width: 2 // 宽度
                }
              }
            }
            if (this.allNameList[z].yAxisIndex === true) { // 是否右轴
              content.yAxisIndex = 1
            } else {
              content.yAxisIndex = 0
            }
            this.allList[query].updataData = nanData
            removeOptionSeries(this.option, query)
            updateOptionSeries(this.option, query, content)
            this.myChart.setOption(this.option) // 原对比数据变更处理
          }
          this.myChart.setOption(this.option)
        }
      }
      this.addNewLine(newTimes, addlabels, nanData, this.addTable.value) // 新x轴 添加x轴 预处理数据 新添加的y轴数据
      this.scatterChart()
    },
    addNewLine (bigTimes, smallTimes, nanData, addData, key, name) { // 添加新数据曲线
      this.oldTimes = bigTimes
      for (let j = 0; j < smallTimes.length; j++) {
        if (bigTimes.indexOf(smallTimes[j]) > -1) {
          let index = bigTimes.indexOf(smallTimes[j])
          nanData[index] = addData[j]
        }
      }
      if (name) {
        var querys = name
      } else if (this.addTemporary.name) {
        querys = this.addTemporary.name
      } else if (this.addTemporary.index_title) {
        querys = this.addTemporary.index_title
      } else {
        querys = this.addTemporary.factor_str
      }
      if (this.addTable.is_bool === true && this.addTable.dimension !== 'two') { // 是否0/1数据
        let item = this.getmarkArea(nanData, bigTimes)
        var markAreaData = item.markAreaData
        var markLineData = item.markLineData
        if (markAreaData.length < 1 && markLineData.length < 1) {
          this.addTable.is_bool = false
        } else {
          var contents = {
            name: querys,
            data: [0],
            type: 'bar',
            connectNulls: false,
            lineStyle: {
              width: 2 // 设置线条粗细
            },
            markArea: {
              data: markAreaData,
              itemStyle: {
                opacity: 0.5
              }
            },
            markLine: {
              data: markLineData,
              symbol: ['none', 'none'], // ['none']表示是一条横线；['arrow', 'none']表示线的左边是箭头，右边没右箭头；['none','arrow']表示线的左边没有箭头，右边有箭头
              label: {
                color: '#FFF',
                position: 'end' // 将警示值放在哪个位置，三个值“start”,"middle","end" 开始 中点 结束
              },
              silent: true, // 鼠标悬停事件 true没有，false有
              lineStyle: { // 警戒线的样式 ，虚实 颜色
                opacity: 0.7,
                type: 'solid', // 样式  ‘solid’和'dotted'
                width: 2 // 宽度
              }
            }
          }
        }
      }
      if (this.addTable.is_bool === false || this.addTable.dimension === 'two') {
        contents = {
          name: querys,
          data: nanData,
          type: 'line',
          connectNulls: true,
          lineStyle: {
            width: 2 // 设置线条粗细
          }
        }
        if (this.addTemporary.yAxisIndex === true) {
          contents.yAxisIndex = 1
        } else {
          contents.yAxisIndex = 0
        }
      }
      this.allList[querys].data = this.addTable.values
      this.allList[querys].label = this.addTable.labels
      this.allList[querys].updataData = nanData
      updateOptionLegend(this.option, querys)
      updateOptionSeries(this.option, querys, contents)
      this.option['legend'].selected[querys] = true
      this.option['dataZoom'][0].startValue = 0
      this.option['dataZoom'][0].endValue = this.theLabels.length
      this.myChart.setOption(this.option)
      this.getRangeY()
      if (key !== 'updata') {
        this.allNameList.push({name: querys, isBool: this.addTable.is_bool, dimension: this.addTable.dimension, id: this.addTable._id, yAxisIndex: this.addTemporary.yAxisIndex})
        this.allNameList = this.uniqueId(this.allNameList)
      }
    },
    updateData (newData, theLabel) { // 只有一条曲线的情况
      let item = this.delectZeroNaN(newData, theLabel)
      this.theDatas = item.theDatas
      this.theLabels = item.theLabels
      this.oldTimes = this.theLabels
      if (this.axisVisited) {
        this.option['yAxis'][0].name = this.lineDetection
      }
      this.allList[this.lineDetection].updataData = this.theDatas
      this.drawLine()
      this.markAreaData = []
      this.markLineData = []
      if (this.detailData.is_bool === true && this.detailData.dimension !== 'two') {
        let item1 = this.getmarkArea(this.theDatas, this.theLabels)
        this.markAreaData = item1.markAreaData
        this.markLineData = item1.markLineData
        this.option['series'][0]['markArea'].data = this.markAreaData
        this.option['series'][0]['markLine'].data = this.markLineData
        this.option['series'][0]['connectNulls'] = false
      }
      if (this.detailData.data_info && this.detailData.data_info.date_desc) {
        let dateDesc = this.detailData.data_info.date_desc
        let item1 = this.getmarkPoint(this.theDatas, this.theLabels, dateDesc)
        this.markPointData = item1
        this.allList[this.lineDetection].markPoint = this.markPointData
        this.option['series'][0]['markPoint'].data = this.markPointData
      }
      this.myChart.setOption(this.option)
      this.getRangeY()
    },
    getmarkArea (data, times) {
      var markAreaData = []
      var markLineData = []
      let i = 0
      for (let j = 0; j < data.length; j++) {
        if (data[j] === 1 && data[j - 1] !== 1 && data[j + 1] === 1) {
          markAreaData[i] = []
          markAreaData[i].push({xAxis: times[j]})
        } else if (data[j] === 1 && data[j - 1] === 1 && data[j + 1] !== 1) {
          markAreaData[i].push({xAxis: times[j]})
          i = i + 1
        } else if (data[j] === 1 && data[j - 1] !== 1 && data[j + 1] !== 1) {
          markLineData.push({xAxis: times[j]})
        }
      }
      return {markAreaData: markAreaData, markLineData: markLineData}
    },
    getmarkPoint (data, times, dateDesc) {
      let markPointData = []
      // let num = 0
      for (let j = 0; j < dateDesc.length; j++) {
        for (let i = 0; i < times.length; i++) {
          if (times[i] >= JSON.stringify(dateDesc[j].date)) {
            // num = i
            markPointData.push({value: dateDesc[j].desc, coord: [times[i], data[i]]})
            break
          }
        }
      }
      return markPointData
    },
    delectZeroNaN (newData, theLabel) { // 去掉0值和空值
      let theDatas = []
      let theLabels = []
      let max = Math.max.apply(null, newData)
      let min = Math.min.apply(null, newData)
      if (max > (1e13 - 1)) {
        this.$notify.error({
          title: '提示',
          message: '数值超过最大值，请检查公式合理性',
          duration: 0
        })
      }
      let value = newData.filter(da => da !== null)
      if (this.hide_nan || this.hide_zero) {
        let allValue = newData
        if (this.hide_nan) {
          allValue = value
        }
        if (this.hide_zero) {
          allValue = allValue.filter(da => da !== 0)
        }
        theDatas = allValue
        for (let j = 0; j < newData.length; j++) {
          if (this.hide_nan && this.hide_zero) {
            if (newData[j] !== null && newData[j] !== 0) {
              theLabels.push(theLabel[j])
            }
          } else if (this.hide_zero) {
            if (newData[j] !== 0) {
              theLabels.push(theLabel[j])
            }
          } else {
            if (newData[j] !== null) {
              theLabels.push(theLabel[j])
            }
          }
        }
      } else {
        theDatas = newData
        theLabels = theLabel
      }
      for (let z = 0; z < theDatas.length; z++) {
        if (typeof theLabels[z] !== 'string') {
          theLabels[z] = JSON.stringify(theLabels[z])
        }
        if (theDatas[z] !== undefined && theDatas[z] !== null) {
          if (max > 10 || min < -10) {
            theDatas[z] = Math.round(1e2 * theDatas[z]) / 1e2
          } else {
            theDatas[z] = Math.round(1e6 * theDatas[z]) / 1e6
          }
        }
      }
      return {theDatas: theDatas, theLabels: theLabels}
      // for (var i = 0; i < this.allNameList.length; i++) {
      //   if (this.allList[this.lineDetection].data) {}
      // }
    },
    getRangeY () { // 适配y轴与边缘的距离
      let rangeY0 = this.myChart.getModel().getComponent('yAxis').axis.scale._extent
      if (rangeY0[0].toString().length > 14 || rangeY0[1].toString().length > 14) {
        this.option['grid'].left = 130
      } else if (rangeY0[0].toString().length > 10 || rangeY0[1].toString().length > 10) {
        this.option['grid'].left = 120
      } else {
        this.option['grid'].left = 80
      }
      let rangeY1 = this.myChart.getModel().getComponent('yAxis', 1).axis.scale._extent
      if (rangeY1[0].toString().length > 14 || rangeY1[1].toString().length > 14) {
        this.option['grid'].right = 130
      } else if (rangeY1[0].toString().length > 10 || rangeY1[1].toString().length > 10) {
        this.option['grid'].right = 120
      } else {
        this.option['grid'].right = 80
      }
      this.myChart.setOption(this.option)
    },
    updataHide () { // 0值空缺值是否去除状态更改
      this.updateData(this.theData, this.theLabel)
      for (let i = 0; i < this.allNameList.length; i++) {
        let boolName = this.allNameList[i].name
        if (boolName !== this.lineDetection) {
          let item = this.delectZeroNaN(this.allList[boolName].data, this.allList[boolName].label)
          let addData = item.theDatas
          let addlabels = item.theLabels
          removeOptionSeries(this.option, boolName)
          // 合并x轴
          let newTimes = this.getNewLabels(addlabels)
          // 处理旧y轴数据曲线，将没有对应日期的value赋一个空值
          let nanData = this.getNaNData(newTimes)
          this.addNewLine(newTimes, addlabels, nanData, addData, 'updata', boolName)
        }
      }
      let nanData = this.getNaNData(this.oldTimes)
      for (let j = 0; j < this.theLabels.length; j++) {
        let index = this.oldTimes.indexOf(this.theLabels[j]) // 新x轴包含旧x轴数据
        if (index > -1) {
          nanData[index] = this.theDatas[j]
        }
      }
      this.updataOneLine(nanData, this.oldTimes)
      // console.log(this.option)
    },

    // 修改图例的方法
    formatLegend (name, yAxisIndex) {
      let nameTag = ''
      if (yAxisIndex === 1) {
        nameTag = '右'
      } else {
        nameTag = '左'
      }
      return `${name}(${nameTag})`
    }
  },
  watch: {
    // 当前的曲线数据
    detailData  (newVal, oldVal) {
      this.detailData = newVal
      if (this.allNameList.length > 0) {
        return
      }
      this.theLabels = []
      this.theDatas = []
      if (this.detailData._id) {
        this.theLabel = this.detailData.labels
        this.theData = this.detailData.values
        if (this.detailData.all_labels) {
          this.theLabel = this.detailData.all_labels
          this.theData = this.detailData.all_values
        }
        this.allList[this.lineDetection] = {}
        this.allNameList[0] = {name: this.lineDetection, isBool: false, dimension: this.detailData.dimension, id: this.detailData._id, yAxisIndex: false}
        this.allList[this.lineDetection].data = this.theData
        this.allList[this.lineDetection].label = this.theLabel
        // console.log(this.allList)
        this.updateData(this.theData, this.theLabel)
      }
    },

    // 深度监听外部，Y轴的展示方向
    yAxisData (newVal, oldVal) {
      this.yAxisData = newVal
      if (this.yAxisData && this.yAxisData._id) {
        for (var i = 0; i < this.allNameList.length; i++) {
          if (this.allNameList[i].id === this.yAxisData._id) {
            var series = this.option.series
            for (var j = 0; j < series.length; j++) {
              if (series[j].name === this.allNameList[i].name) {
                if (this.yAxisData.yAxisIndex === true) {
                  this.option.series[j].yAxisIndex = 1
                } else {
                  this.option.series[j].yAxisIndex = 0
                }
                this.myChart.setOption(this.option)
                this.getRangeY()
                return
              }
            }
          }
        }
      }
    },
    delectedTemporary (newVal, oldVal) {
      this.delectedTemporary = newVal
      if (this.delectedTemporary && this.delectedTemporary._id) {
        for (let i = 0; i < this.allNameList.length; i++) {
          if (this.allNameList[i].id === this.delectedTemporary._id) {
            this.option['legend'].selected[this.allNameList[i].name] = false
            removeOptionLegend(this.option, this.allNameList[i].name)
            removeOptionSeries(this.option, this.allNameList[i].name)
            this.option['series'][0]['markArea'].data = []
            this.option['series'][0]['markLine'].data = []
            if (this.markAreaData.length > 0) {
              this.option['series'][0]['markArea'].data = this.markAreaData
            }
            if (this.markLineData.length > 0) {
              this.option['series'][0]['markLine'].data = this.markLineData
            }
            if (this.markLineData.length < 1 && this.markAreaData.length < 1) {
              this.option['series'][0].data = this.theDatas
            } else {
              this.option['series'][0].type = 'bar'
              this.option['series'][0].data = [0]
            }
            this.myChart.setOption(this.option)
            delete this.allList[this.allNameList[i].name]
            this.serieData = []
            this.allNameList.splice(i, 1)
            if (this.option.series.length === 2 || this.option.series.length === 3) {
              this.scatterChart()
            }
            this.myChart.setOption(this.option, true)
            this.getRangeY()
            return
          }
        }
      }
    },
    // 每次新增一条曲线的数据
    addTemporary (newVal, oldVal) {
      this.addTemporary = newVal
      this.addTable = {}
      if (this.addTemporary && this.addTemporary._id) {
        for (let i = 0; i < this.allNameList.length; i++) {
          if (this.allNameList[i].id === this.addTemporary._id) {
            removeOptionSeries(this.option, this.allNameList[i].name)
            removeOptionLegend(this.option, this.allNameList[i].name)
            this.serieData = []
            this.allNameList.splice(i, 1)
            this.scatterChart()
            return
          } else {
            var querys = ''
            if (this.addTemporary.name) {
              querys = this.addTemporary.name
            } else if (this.addTemporary.index_title) {
              querys = this.addTemporary.index_title
            } else {
              querys = this.addTemporary.factor_str
            }
            if (this.allNameList[i].name === querys) {
              return
            }
          }
        }
        var _this = this
        getRequest('/timeSeries/requestIndexDetail', {id: this.addTemporary._id}).then(function (x) {
          if (!x.data.message) {
            let values = x.data.data.values
            let labels = x.data.data.labels
            _this.addTable = x.data.data
            _this.addTable.value = []
            _this.addTable.label = []
            _this.allList[querys] = {}
            if (_this.addTable.is_bool === true && _this.addTable.dimension !== 'two') {
              _this.addTable.value = values
              _this.addTable.label = labels
            } else {
              let item = _this.delectZeroNaN(values, labels)
              _this.addTable.value = item.theDatas
              _this.addTable.label = item.theLabels
            }
            _this.updataLine(_this.addTable.label)
          }
        })
      }
    },
    hide_zero (newVal, oldVal) {
      this.hide_zero = newVal
      // console.log('this.hide_zero', this.allNameList)
      if (this.allNameList.length === 1) {
        this.updateData(this.theData, this.theLabel)
      } else if (this.allNameList.length > 1) {
        // console.log('this.hide_zero', this.hide_zero)
        this.updataHide()
      }
    },
    hide_nan (newVal, oldVal) {
      this.hide_nan = newVal
      // console.log('this.hide_nan', this.allNameList)
      if (this.allNameList.length === 1) {
        this.updateData(this.theData, this.theLabel)
      } else if (this.allNameList.length > 1) {
        // console.log('this.hide_nan', this.hide_nan)
        this.updataHide()
      }
    },
    id (newVal, oldVal) {
      this.id = newVal
      this.drawLine()
    },
    lineDetection (newVal, oldVal) {
      this.lineDetection = newVal
    },
    axisVisited (newVal, oldVal) {
      this.axisVisited = newVal
      if (this.axisVisited) {
        this.option['yAxis'][0].name = this.lineDetection
      } else {
        this.option['yAxis'][0].name = ''
      }
    },
    auto_scatter_plot (newVal, oldVal) {
      this.auto_scatter_plot = newVal
    },
    activeName () {
      if (this.myChart) {
        this.myChart.resize()
      }
    }
  },
  activated () {
    this.clearData()
  }
}
</script>
<style scoped>
  .el-collapse-item {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__header {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  .el-collapse-item__wrap {
    background-color: rgba(255, 255, 255, 0) !important;
  }
  h4 {
    margin-bottom:0px;
  }
  .bannerTextRed{
    padding: 0 4px;
    line-height: 18px;
    height: 18px;
    border-radius: 4px;
    font-weight: 400;
    background-color:indianred;
    color:white;
    font-size: 13px;
  }
</style>



// WEBPACK FOOTER //
// src/components/allPage/factorLine.vue